"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pane = exports.paneShadowMixin = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_get_1 = require("@styled-system/theme-get");
var use_keyboard_list_navigation_1 = require("use-keyboard-list-navigation");
var compose_react_refs_1 = __importDefault(require("@seznam/compose-react-refs"));
var Stack_1 = require("../Stack");
var flattenChildren_1 = require("../lib/flattenChildren");
var PaneOption_1 = require("./PaneOption");
var Flyout_1 = require("../Flyout");
exports.paneShadowMixin = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0 0 ", " 0 ", ";\n"], ["\n  box-shadow: 0 0 ", " 0 ", ";\n"])), (0, theme_get_1.themeGet)("space.2"), (0, theme_get_1.themeGet)("colors.tertiary"));
var Container = (0, styled_components_1.default)(Stack_1.Stack)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  max-width: ", ";\n  ", "\n"], ["\n  background-color: ", ";\n  max-width: ", ";\n  ", "\n"])), (0, theme_get_1.themeGet)("colors.background"), (0, theme_get_1.themeGet)("space.10"), exports.paneShadowMixin);
Container.defaultProps = {
    borderRadius: 4,
    spacing: 0,
};
exports.Pane = react_1.default.forwardRef(function (_a, forwardedRef) {
    var children = _a.children, _b = _a.onEnter, onEnter = _b === void 0 ? function () { } : _b, rest = __rest(_a, ["children", "onEnter"]);
    var ref = (0, react_1.useRef)(null);
    var composedRef = (0, compose_react_refs_1.default)(ref, forwardedRef);
    var nodes = (0, flattenChildren_1.flattenChildren)(children);
    var clickable = nodes.filter(function (element) {
        var isAnchor = element.type === "a";
        var isButton = element.type === "button";
        var isSystem = element.type === PaneOption_1.PaneOption || element.type === Flyout_1.Flyout;
        var isClickable = !!element.props.onClick;
        var isNotDisabled = !element.props.disabled;
        return (isAnchor || isButton || isSystem || isClickable) && isNotDisabled;
    });
    var refs = clickable.map(function () { return (0, react_1.createRef)(); });
    var index = (0, use_keyboard_list_navigation_1.useKeyboardListNavigation)({
        list: clickable,
        ref: composedRef,
        waitForInteractive: true,
        onEnter: onEnter,
    }).index;
    (0, react_1.useEffect)(function () {
        var _a, _b;
        (_b = (_a = refs[index]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
    }, [index, refs]);
    return (react_1.default.createElement(Container, __assign({ ref: composedRef }, rest), nodes.map(function (child, i) {
        return react_1.default.cloneElement(child, __assign({ key: i }, (clickable.indexOf(child) !== -1
            ? { ref: refs[clickable.indexOf(child)] }
            : {})));
    })));
});
exports.Pane.displayName = "Pane";
var templateObject_1, templateObject_2;
//# sourceMappingURL=Pane.js.map